/* !!! DO NOT EDIT !!! */ /* This file has been generated by the token pipeline */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "generateColorTokens", {
    enumerable: true,
    get: function() {
        return generateColorTokens;
    }
});
const _colors = require("../global/colors");
const generateColorTokens = (brand)=>({
        colorNeutralForeground1: _colors.white,
        colorNeutralForeground1Hover: _colors.white,
        colorNeutralForeground1Pressed: _colors.white,
        colorNeutralForeground1Selected: _colors.white,
        colorNeutralForeground2: _colors.grey[84],
        colorNeutralForeground2Hover: _colors.white,
        colorNeutralForeground2Pressed: _colors.white,
        colorNeutralForeground2Selected: _colors.white,
        colorNeutralForeground2BrandHover: brand[100],
        colorNeutralForeground2BrandPressed: brand[90],
        colorNeutralForeground2BrandSelected: brand[100],
        colorNeutralForeground3: _colors.grey[68],
        colorNeutralForeground3Hover: _colors.grey[84],
        colorNeutralForeground3Pressed: _colors.grey[84],
        colorNeutralForeground3Selected: _colors.grey[84],
        colorNeutralForeground3BrandHover: brand[100],
        colorNeutralForeground3BrandPressed: brand[90],
        colorNeutralForeground3BrandSelected: brand[100],
        colorNeutralForeground4: _colors.grey[60],
        colorNeutralForegroundDisabled: _colors.grey[36],
        colorNeutralForegroundInvertedDisabled: _colors.whiteAlpha[40],
        colorBrandForegroundLink: brand[100],
        colorBrandForegroundLinkHover: brand[110],
        colorBrandForegroundLinkPressed: brand[90],
        colorBrandForegroundLinkSelected: brand[100],
        colorNeutralForeground2Link: _colors.grey[84],
        colorNeutralForeground2LinkHover: _colors.white,
        colorNeutralForeground2LinkPressed: _colors.white,
        colorNeutralForeground2LinkSelected: _colors.white,
        colorCompoundBrandForeground1: brand[100],
        colorCompoundBrandForeground1Hover: brand[110],
        colorCompoundBrandForeground1Pressed: brand[90],
        colorBrandForeground1: brand[100],
        colorBrandForeground2: brand[110],
        colorBrandForeground2Hover: brand[130],
        colorBrandForeground2Pressed: brand[160],
        colorNeutralForeground1Static: _colors.grey[14],
        colorNeutralForegroundStaticInverted: _colors.white,
        colorNeutralForegroundInverted: _colors.grey[14],
        colorNeutralForegroundInvertedHover: _colors.grey[14],
        colorNeutralForegroundInvertedPressed: _colors.grey[14],
        colorNeutralForegroundInvertedSelected: _colors.grey[14],
        colorNeutralForegroundInverted2: _colors.grey[14],
        colorNeutralForegroundOnBrand: _colors.white,
        colorNeutralForegroundInvertedLink: _colors.white,
        colorNeutralForegroundInvertedLinkHover: _colors.white,
        colorNeutralForegroundInvertedLinkPressed: _colors.white,
        colorNeutralForegroundInvertedLinkSelected: _colors.white,
        colorBrandForegroundInverted: brand[80],
        colorBrandForegroundInvertedHover: brand[70],
        colorBrandForegroundInvertedPressed: brand[60],
        colorBrandForegroundOnLight: brand[80],
        colorBrandForegroundOnLightHover: brand[70],
        colorBrandForegroundOnLightPressed: brand[50],
        colorBrandForegroundOnLightSelected: brand[60],
        colorNeutralBackground1: _colors.grey[16],
        colorNeutralBackground1Hover: _colors.grey[24],
        colorNeutralBackground1Pressed: _colors.grey[12],
        colorNeutralBackground1Selected: _colors.grey[22],
        colorNeutralBackground2: _colors.grey[12],
        colorNeutralBackground2Hover: _colors.grey[20],
        colorNeutralBackground2Pressed: _colors.grey[8],
        colorNeutralBackground2Selected: _colors.grey[18],
        colorNeutralBackground3: _colors.grey[8],
        colorNeutralBackground3Hover: _colors.grey[16],
        colorNeutralBackground3Pressed: _colors.grey[4],
        colorNeutralBackground3Selected: _colors.grey[14],
        colorNeutralBackground4: _colors.grey[4],
        colorNeutralBackground4Hover: _colors.grey[12],
        colorNeutralBackground4Pressed: _colors.black,
        colorNeutralBackground4Selected: _colors.grey[10],
        colorNeutralBackground5: _colors.black,
        colorNeutralBackground5Hover: _colors.grey[8],
        colorNeutralBackground5Pressed: _colors.grey[2],
        colorNeutralBackground5Selected: _colors.grey[6],
        colorNeutralBackground6: _colors.grey[20],
        colorNeutralBackgroundInverted: _colors.white,
        colorNeutralBackgroundStatic: _colors.grey[24],
        colorNeutralBackgroundAlpha: _colors.grey10Alpha[50],
        colorNeutralBackgroundAlpha2: _colors.grey12Alpha[70],
        colorSubtleBackground: 'transparent',
        colorSubtleBackgroundHover: _colors.grey[22],
        colorSubtleBackgroundPressed: _colors.grey[18],
        colorSubtleBackgroundSelected: _colors.grey[20],
        colorSubtleBackgroundLightAlphaHover: _colors.grey14Alpha[80],
        colorSubtleBackgroundLightAlphaPressed: _colors.grey14Alpha[50],
        colorSubtleBackgroundLightAlphaSelected: 'transparent',
        colorSubtleBackgroundInverted: 'transparent',
        colorSubtleBackgroundInvertedHover: _colors.blackAlpha[10],
        colorSubtleBackgroundInvertedPressed: _colors.blackAlpha[30],
        colorSubtleBackgroundInvertedSelected: _colors.blackAlpha[20],
        colorTransparentBackground: 'transparent',
        colorTransparentBackgroundHover: 'transparent',
        colorTransparentBackgroundPressed: 'transparent',
        colorTransparentBackgroundSelected: 'transparent',
        colorNeutralBackgroundDisabled: _colors.grey[8],
        colorNeutralBackgroundInvertedDisabled: _colors.whiteAlpha[10],
        colorNeutralStencil1: _colors.grey[34],
        colorNeutralStencil2: _colors.grey[20],
        colorNeutralStencil1Alpha: _colors.whiteAlpha[10],
        colorNeutralStencil2Alpha: _colors.whiteAlpha[5],
        colorBackgroundOverlay: _colors.blackAlpha[50],
        colorScrollbarOverlay: _colors.whiteAlpha[60],
        colorBrandBackground: brand[70],
        colorBrandBackgroundHover: brand[80],
        colorBrandBackgroundPressed: brand[40],
        colorBrandBackgroundSelected: brand[60],
        colorCompoundBrandBackground: brand[100],
        colorCompoundBrandBackgroundHover: brand[110],
        colorCompoundBrandBackgroundPressed: brand[90],
        colorBrandBackgroundStatic: brand[80],
        colorBrandBackground2: brand[20],
        colorBrandBackground2Hover: brand[40],
        colorBrandBackground2Pressed: brand[10],
        colorBrandBackgroundInverted: _colors.white,
        colorBrandBackgroundInvertedHover: brand[160],
        colorBrandBackgroundInvertedPressed: brand[140],
        colorBrandBackgroundInvertedSelected: brand[150],
        colorNeutralStrokeAccessible: _colors.grey[68],
        colorNeutralStrokeAccessibleHover: _colors.grey[74],
        colorNeutralStrokeAccessiblePressed: _colors.grey[70],
        colorNeutralStrokeAccessibleSelected: brand[100],
        colorNeutralStroke1: _colors.grey[40],
        colorNeutralStroke1Hover: _colors.grey[46],
        colorNeutralStroke1Pressed: _colors.grey[42],
        colorNeutralStroke1Selected: _colors.grey[44],
        colorNeutralStroke2: _colors.grey[32],
        colorNeutralStroke3: _colors.grey[24],
        colorNeutralStrokeSubtle: _colors.grey[4],
        colorNeutralStrokeOnBrand: _colors.grey[16],
        colorNeutralStrokeOnBrand2: _colors.white,
        colorNeutralStrokeOnBrand2Hover: _colors.white,
        colorNeutralStrokeOnBrand2Pressed: _colors.white,
        colorNeutralStrokeOnBrand2Selected: _colors.white,
        colorBrandStroke1: brand[100],
        colorBrandStroke2: brand[50],
        colorBrandStroke2Hover: brand[50],
        colorBrandStroke2Pressed: brand[30],
        colorBrandStroke2Contrast: brand[50],
        colorCompoundBrandStroke: brand[100],
        colorCompoundBrandStrokeHover: brand[110],
        colorCompoundBrandStrokePressed: brand[90],
        colorNeutralStrokeDisabled: _colors.grey[26],
        colorNeutralStrokeInvertedDisabled: _colors.whiteAlpha[40],
        colorTransparentStroke: 'transparent',
        colorTransparentStrokeInteractive: 'transparent',
        colorTransparentStrokeDisabled: 'transparent',
        colorNeutralStrokeAlpha: _colors.whiteAlpha[10],
        colorNeutralStrokeAlpha2: _colors.whiteAlpha[20],
        colorStrokeFocus1: _colors.black,
        colorStrokeFocus2: _colors.white,
        colorNeutralShadowAmbient: 'rgba(0,0,0,0.24)',
        colorNeutralShadowKey: 'rgba(0,0,0,0.28)',
        colorNeutralShadowAmbientLighter: 'rgba(0,0,0,0.12)',
        colorNeutralShadowKeyLighter: 'rgba(0,0,0,0.14)',
        colorNeutralShadowAmbientDarker: 'rgba(0,0,0,0.40)',
        colorNeutralShadowKeyDarker: 'rgba(0,0,0,0.48)',
        colorBrandShadowAmbient: 'rgba(0,0,0,0.30)',
        colorBrandShadowKey: 'rgba(0,0,0,0.25)'
    });
